import { MetricTooltip } from './MetricTooltip'
import styles from './KPICard.module.css'

export function KPICard({ label, value, subvalue, subvalueColor, delta, tooltip, source, color, suffix }) {
  const deltaPositive = delta !== null && delta !== undefined && delta > 0
  const deltaNegative = delta !== null && delta !== undefined && delta < 0

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        {tooltip && <MetricTooltip description={tooltip} source={source} />}
      </div>

      <div className={styles.value} style={color ? { color } : undefined}>
        {value !== null && value !== undefined ? value : '—'}
        {suffix && value !== null && value !== undefined && (
          <span className={styles.suffix}>{suffix}</span>
        )}
      </div>

      {(subvalue !== undefined || delta !== null) && (
        <div className={styles.footer}>
          {subvalue && (
            <span className={`${styles.subvalue} ${
              subvalueColor === 'positive' ? styles.subPositive
                : subvalueColor === 'negative' ? styles.subNegative
                : ''
            }`}>{subvalue}</span>
          )}
          {delta !== null && delta !== undefined && (
            <span className={`${styles.delta} ${deltaPositive ? styles.positive : deltaNegative ? styles.negative : styles.neutral}`}>
              {deltaPositive ? '↑' : deltaNegative ? '↓' : '='}
              {' '}{Math.abs(delta)}%
            </span>
          )}
        </div>
      )}
    </div>
  )
}
